import { render, staticRenderFns } from "./AgentTable.vue?vue&type=template&id=19de349b&scoped=true"
import script from "./AgentTable.vue?vue&type=script&lang=js"
export * from "./AgentTable.vue?vue&type=script&lang=js"
import style0 from "./AgentTable.vue?vue&type=style&index=0&id=19de349b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19de349b",
  null
  
)

export default component.exports